import type {
  User,
  LoginFormValues,
} from '@viome/viome-base/src/usecase/Login/Login.model';
import { KEYS, LocalStorage } from '@/utils/LocalStorage';
import { useUserData } from '@viome/viome-base/src/usecase/Login/UserQuery';
import { useUserStore } from '@hooks/useUserStore';
import useRegisterStore from './useRegistrationStore';
import { setSentryUser } from '@/main.tsx';
import { EventTracker } from '@/utils';

const useUser = () => {
  const { setUser } = useUserStore();
  const localStorageUser = LocalStorage.getItem(KEYS.USER);
  const { setClearRegisterState } = useRegisterStore();
  const { user: queryUser } = useUserData();
  const user = queryUser || localStorageUser;

  const onLoginSuccess = (userData: User, formData?: LoginFormValues) => {
    // clearing the existing 
    if (LocalStorage.getItem('register')) {
      setClearRegisterState();
    }
    LocalStorage.setItem(KEYS.USER, JSON.stringify(userData));
    setUser(userData?.data);
    const userId = userData?.data?.userID;
    const userName = userData?.data?.fullName;
    const userEmail = userData?.data?.email;
    setSentryUser({ userId, name: userName, email: userEmail });
    EventTracker.setUserValues({ userId, email: userEmail });
  };

  return { user, onLoginSuccess };
};

export default useUser;
